import {
    BarElement,
    CategoryScale,
    Chart,
    LinearScale,
    Title,
    Tooltip,
} from "chart.js"
import React, {useContext, useMemo} from "react"
import {Bar} from "react-chartjs-2"
import {
    fillTopLabels,
} from "./stacked-barchart-widget/chart-utils"
import {DataContext} from "../../../src/context/DataContextProvider"

Chart.register(CategoryScale, LinearScale, BarElement, Title, Tooltip)

const options = (labels) => ({
    plugins: {
        tooltip: {
            bodyAlign: "center", bodyFont: {
                family: 'SI Sans',
                weight: 'bold',
                size: 14,
            },
            callbacks: {
                title: () => "",
                label: (data) => [data.dataset.label + ":", (data.raw).toLocaleString("de-DE", {
                    style: "currency", currency: "EUR", minimumFractionDigits: 2,
                })],
            },
        },
    },
    datasets: {
        bar: {
            barThickness: 48, borderRadius: 4,
        },
    },
    maintainAspectRatio: false,
    aspectRatio: 1,
    responsive: true,
    scales: {
        x: {
            border: {
                display: false,
            },
            position: "bottom", stacked: true, grid: {
                display: false,
            },
            ticks: {
                color: "black",
                font: {
                    family: 'SI Sans',
                    weight: 400,
                    size: 14,
                },
                callback: (_, index) => labels[index],
            },
        },
        y: {
            border: {
                display: false,
            },
            stacked: true,
            grid: {
                display: false,
            },
            ticks: {
                display: false,
            },
        },
    },
})

const SiStackedBarchartWidget = ({widget}) => {
    const {getDataFromPointer} = useContext(DataContext)
    const pointer = useMemo(
        () => widget?.connections?.origin?.pointer,
        [widget],
    )
    const data = getDataFromPointer(pointer)

    const chartData = useMemo(
        () => ({
            labels: data?.bottomLabels ?? fillTopLabels(data),
            datasets: data?.datasets ?? [],
        }),
        [data],
    )

    return (
        <div style={{height: "100%", width: "100%"}}>
            <Bar
                options={options(data?.topLabels ?? fillTopLabels(data))}
                data={chartData}
            />
        </div>
    )
}

export default SiStackedBarchartWidget
